import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

// Import images
import janaLogo from './Jana logo white.png';
import image004 from './image004.jpg';
import socialBytes from './social_bytes.png';

const Ribbon = () => (
  <div className="bg-white border-top w-100">
    {/* Removed bottom padding to fix gap */}
    <Container
      fluid
      className="pt-3 px-4 mb-5"
      style={{ paddingBottom: '0px', }}
    >

      {/* Flex layout: 60% center content + 40% right links */}
      <div style={{ display: 'flex', width: '100%' }}>

        {/* LEFT SECTION – 60% width */}
        <div style={{ width: '100%', margin: '0 auto' }}>
          <Row
            className="justify-content-center align-items-center mx-2"
            style={{ columnGap: '40px', marginBottom: '0px' }}
          >

            {/* Created By Section */}
            <Col
              xs={12}
              md="auto"
              className="text-center mb-3 mb-md-0 d-flex flex-column justify-content-center align-items-center"
              style={{ minHeight: 80 }}
            >
              <p className="text mb-2 fs--2 fw-medium">Conceived, Created, and Operated By</p>

              <div className="d-flex flex-column justify-content-center align-items-center gap-2">
                <a alt="Janaagraha" href="https://www.janaagraha.org/home/" target="_blank" >
                <img
                  src={janaLogo}
                  alt="Janaagraha"
                  style={{ maxHeight: 60, maxWidth: 180 }}
                  className="img-fluid"
                /></a>
                {/* <img
                  src={image004}
                  alt="Partner"
                  style={{ maxHeight: 60, maxWidth: 180 }}
                  className="img-fluid"
                /> */}
              </div>
            </Col>
            {/* 🔹 ADDED VERTICAL DIVIDER BETWEEN SECTIONS */}
  <div
    className="d-none d-md-block p-0"
    style={{
      width: '1px',
      height: '70px',
      backgroundColor: '#dee2e6'
    }}
  />

            {/* Technical Collaborators Section */}
            <Col
              xs={12}
              md="auto"
              className="text-center text-md-start d-flex flex-column justify-content-center align-items-center align-items-md-start"
              style={{ minHeight: 80 }}
            >
              <div className='d-flex justify-content-center justify-content-md-center align-items-center col-md-12 col-12'>
                <p className="text mb-2 fs--2 fw-medium">Technical Collaborators</p>
              </div>
              <div className="d-flex justify-content-center justify-content-md-start align-items-center gap-4">
                <a alt="Social Bytes" href="https://thesocialbytes.com/" target="_blank" >
                <img
                  src={socialBytes}
                  alt="Social Bytes"
                  style={{ maxHeight: 55, maxWidth: 140 }}
                  className="img-fluid"
                /></a>

                {/* Divider */}
                <div style={{ width: '1px', height: '44px', backgroundColor: '#dee2e6' }} />

                {/* IBM Text */}
                <div className="text-center px-3" style={{ fontSize: '14px', lineHeight: '16px', border: '1px solid #cecece' ,padding: '12px '}}>
                  <center>
                    IBM through the <br /> IBM Impact Accelerator
                  </center>
                </div>
              </div>
            </Col>

          </Row>
        </div>

        {/* RIGHT LINKS SECTION – 40% width */}
        {/* <div
          style={{
            width: '40%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',

            // spacing between left and right
            marginLeft: '40px',
            paddingLeft: '20px',
            borderLeft: '1px solid #e5e5e5'
          }}
        >
          <a href="/demo" style={{ fontSize: '14px' }}>Demo</a>

          <a href="/about-cdap" style={{ fontSize: '14px' }}>
            About CDAP
          </a>

          <a
            href="https://forms.gle/SSeUZUY4ddKXpBZx7"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '14px' }}
          >
            Contact Us
          </a>
        </div> */}

      </div>
    </Container>
  </div>
);

export default Ribbon;
